import React from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
} from '@chakra-ui/react';

const Privacy = () => {
  return (
    <Container maxW="800px" py={10}>
      <VStack spacing={8} align="stretch">
        <Box>
          <Heading as="h1" size="xl" mb={4}>
            Privacy Policy
          </Heading>
          <Text fontSize="lg">
            We take your privacy seriously. This policy explains how we collect, use, and protect your information.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={3}>
            Information We Collect
          </Heading>
          <Text>
            We collect the following information when you submit a report through our platform:
          </Text>
          <Text mt={2}>
            <strong>NIH Award Number:</strong> This helps us categorize and analyze termination patterns.
          </Text>
          <Text mt={2}>
            <strong>Termination Notice Content:</strong> This helps us understand the reasons given for terminations.
          </Text>
          <Text mt={2}>
            <strong>Contact Email (Optional):</strong> We only collect this if you voluntarily provide it for follow-up communication.
          </Text>
          <Text mt={2}>
            <strong>Additional Information:</strong> Any other details you choose to share about your grant or termination experience.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={3}>
            How We Use Your Information
          </Heading>
          <Text>
            The information you provide is used to:
          </Text>
          <Text mt={2}>
            - Compile anonymous statistics about NIH grant terminations
          </Text>
          <Text mt={2}>
            - Understand patterns and trends in the termination notices
          </Text>
          <Text mt={2}>
            - Follow up with you if you provided contact information and consent
          </Text>
          <Text mt={2}>
            We never share your personal information with third parties without your explicit consent.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={3}>
            Data Security
          </Heading>
          <Text>
            We use Supabase, a secure database platform, to store all submitted information. 
            Your data is encrypted in transit and at rest. We implement appropriate security 
            measures to protect against unauthorized access or disclosure of your information.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={3}>
            Your Rights
          </Heading>
          <Text>
            You have the right to:
          </Text>
          <Text mt={2}>
            - Request access to the personal information we have about you
          </Text>
          <Text mt={2}>
            - Request correction of your personal information
          </Text>
          <Text mt={2}>
            - Request deletion of your personal information
          </Text>
          <Text mt={2}>
            - Withdraw your consent at any time
          </Text>
          <Text mt={4}>
            To exercise any of these rights, please contact us through our Contact page.
          </Text>
        </Box>

        <Box>
          <Heading as="h2" size="lg" mb={3}>
            Changes to This Policy
          </Heading>
          <Text>
            We may update this privacy policy from time to time. We will notify you of any 
            changes by posting the new privacy policy on this page.
          </Text>
        </Box>
      </VStack>
    </Container>
  );
};

export default Privacy;